<div class="modal-header">
  <h4 class="modal-title">Insert Customer Region Entry</h4>
  <button type="button" class="btn p-0 border-0 bg-transparent fs-4 lh-1" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form #insertForm="ngForm" autocomplete="off" novalidate>
    <!--Billing Account Id-->
    <div class="form-group"
      [ngClass]="{
        error: insertForm.controls.billingAccountId?.invalid && insertForm.controls.billingAccountId?.touched
      }">
      <label for="billingAccountId">Billing Account Id</label>
      <input
        class="form-control"
        [(ngModel)]="billingAccountId"
        name="billingAccountId"
        title="billingAccountId"
        id="billingAccountId"
        type="text"
        placeholder="Enter Billing Account Id"
        required
        pattern="[a-zA-Z0-9_:-]+"
      />
      <em *ngIf="insertForm.controls.billingAccountId?.invalid && insertForm.controls.billingAccountId?.touched">
        Billing Account Id is required and must be alphanumeric (can include '-', '_', and ':')
      </em>
    </div>

    <!--Regions-->
    <div class="form-group"
      [ngClass]="{
        error: insertForm.controls.region?.invalid && insertForm.controls.region?.touched
      }">
      <label for="region">Regions</label>
      <ng-select
        name="region"
        labelForId="region"
        [items]="regionsList"
        bindLabel="region"
        bindValue="region"
        groupBy="cloud"
        required
        [(ngModel)]="selectedRegion"
        placeholder="Select a region"
      >
      </ng-select>
      <em *ngIf="insertForm.controls.region?.invalid && insertForm.controls.region?.touched">Region is required</em>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="insertForm.invalid" (click)="onSubmit()">Yes</button>
  <button type="button" class="btn btn-secondary" (click)="onCancel()">No</button>
</div>
